import React, { Component } from 'react';
import { Container, Row, Col } from "reactstrap";

//Import Components
import SectionTitle from "../../components/Shared/section-title";
// import TeamBox from "../../components/Shared/team-box";
import BlockContainer from "./block-container";

//Import Images
import image1 from "../../images/client/01.jpg";
import image2 from "../../images/client/01.jpg";
import image3 from "../../images/client/01.jpg";
import image4 from "../../images/client/01.jpg";

import offer from "../../images/onepage/concept.png";
import Price from "./price";

class Team extends Component {
    state = {
        candidates : [
            { id : 1, image : image1, name : "Ronny Jofra", designation : "Web Developer", salary : "2300", link : "",
                socialIds : [
                    { icon : "mdi-facebook", link : "#" },
                    { icon : "mdi-instagram", link : "#" },
                    { icon : "mdi-twitter", link : "#" },
                    { icon : "mdi-google-plus", link : "#" },
                ]
            },
            { id : 2, image : image2, name : "Micheal Carlo", designation : "Web Designer", salary : "1950", link : "",
                socialIds : [
                    { icon : "mdi-facebook", link : "#" },
                    { icon : "mdi-instagram", link : "#" },
                    { icon : "mdi-twitter", link : "#" },
                    { icon : "mdi-google-plus", link : "#" },
                ]
            },
            { id : 3, image : image3, name : "Aliana Rosy", designation : "IOS Developer", salary : "2540", link : "",
                socialIds : [
                    { icon : "mdi-facebook", link : "#" },
                    { icon : "mdi-instagram", link : "#" },
                    { icon : "mdi-twitter", link : "#" },
                    { icon : "mdi-google-plus", link : "#" },
                ]
            },
            { id : 4, image : image4, name : "Sofia Razaq", designation : "Php Developer", salary : "2190", link : "",
                socialIds : [
                    { icon : "mdi-facebook", link : "#" },
                    { icon : "mdi-instagram", link : "#" },
                    { icon : "mdi-twitter", link : "#" },
                    { icon : "mdi-google-plus", link : "#" },
                ]
            },
        ]
    }

    componentDidMount(){
        var teambox = document.getElementsByName("team");
        for ( var i=0; i<teambox.length; i++){
            teambox[i].classList.remove("rounded");
            teambox[i].classList.remove("bg-white");
            teambox[i].classList.remove("pt-3");
        }
    }

    render() {
        return (
            <React.Fragment>
                    <Container>
                        <Row  className="align-items-center">
                            <Col lg="12" md="12" className="mt-1 pt-1 order-1 order-md-2">
                                {/* <SectionTitle title="Premium. Free. Unrestricted" desc="Download premium version of TelegramTradeCopier for demo accounts, unlimited telegram channels, unlimited message for FREE"/>  */}
                                <BlockContainer/>
                            </Col> 
                        </Row>
                        <Row  className="align-items-center">   
                            {/* <Col lg="6" md="6" className="mt-4 pt-2 order-1 order-md-2">
                                <img width="940" height="7" src={offer} className="rounded img-fluid mx-auto d-block" alt=""/>
                            </Col>    */}
                            <Col lg="12" md="12" className="mt-1 pt-1 order-1 order-md-2">
                                <Price/>

                            </Col>

                        </Row>                                        
                    </Container>                    
            </React.Fragment>
        );
    }
}

export default Team;